const AirportCodesData=[
    {
     Country: "Afghanistan",
     AlphaTwo: "AF",
     AlphaThree: "AFG"
   },
   {
     Country: "Albania",
     AlphaTwo: "AL",
     AlphaThree: "ALB"
   },
   {
     Country: "Algeria",
     AlphaTwo: "DZ",
     AlphaThree: "DZA"
   },
   {
     Country: "American Samoa",
     AlphaTwo: "AS",
     AlphaThree: "ASM"
   },
   {
     Country: "Andorra",
     AlphaTwo: "AD",
     AlphaThree: "AND"
   },
   {
     Country: "Angola",
     AlphaTwo: "AO",
     AlphaThree: "AGO"
   },
   {
     Country: "Anguilla",
     AlphaTwo: "AI",
     AlphaThree: "AIA"
   },
   {
     Country: "Antarctica",
     AlphaTwo: "AQ",
     AlphaThree: "ATA"
   },
   {
     Country: "Antigua and Barbuda",
     AlphaTwo: "AG",
     AlphaThree: "ATG"
   },
   {
     Country: "Argentina",
     AlphaTwo: "AR",
     AlphaThree: "ARG"
   },
   {
     Country: "Armenia",
     AlphaTwo: "AM",
     AlphaThree: "ARM"
   },
   {
     Country: "Aruba",
     AlphaTwo: "AW",
     AlphaThree: "ABW"
   },
   {
     Country: "Australia",
     AlphaTwo: "AU",
     AlphaThree: "AUS"
   },
   {
     Country: "Austria",
     AlphaTwo: "AT",
     AlphaThree: "AUT"
   },
   {
     Country: "Azerbaijan",
     AlphaTwo: "AZ",
     AlphaThree: "AZE"
   },
   {
     Country: "Bahamas (the)",
     AlphaTwo: "BS",
     AlphaThree: "BHS"
   },
   {
     Country: "Bahrain",
     AlphaTwo: "BH",
     AlphaThree: "BHR"
   },
   {
     Country: "Bangladesh",
     AlphaTwo: "BD",
     AlphaThree: "BGD"
   },
   {
     Country: "Barbados",
     AlphaTwo: "BB",
     AlphaThree: "BRB"
   },
   {
     Country: "Belarus",
     AlphaTwo: "BY",
     AlphaThree: "BLR"
   },
   {
     Country: "Belgium",
     AlphaTwo: "BE",
     AlphaThree: "BEL"
   },
   {
     Country: "Belize",
     AlphaTwo: "BZ",
     AlphaThree: "BLZ"
   },
   {
     Country: "Benin",
     AlphaTwo: "BJ",
     AlphaThree: "BEN"
   },
   {
     Country: "Bermuda",
     AlphaTwo: "BM",
     AlphaThree: "BMU"
   },
   {
     Country: "Bhutan",
     AlphaTwo: "BT",
     AlphaThree: "BTN"
   },
   {
     Country: "Bolivia (Plurinational State of)",
     AlphaTwo: "BO",
     AlphaThree: "BOL"
   },
   {
     Country: "Bonaire, Sint Eustatius and Saba",
     AlphaTwo: "BQ",
     AlphaThree: "BES"
   },
   {
     Country: "Bosnia and Herzegovina",
     AlphaTwo: "BA",
     AlphaThree: "BIH"
   },
   {
     Country: "Botswana",
     AlphaTwo: "BW",
     AlphaThree: "BWA"
   },
   {
     Country: "Bouvet Island",
     AlphaTwo: "BV",
     AlphaThree: "BVT"
   },
   {
     Country: "Brazil",
     AlphaTwo: "BR",
     AlphaThree: "BRA"
   },
   {
     Country: "British Indian Ocean Territory (the)",
     AlphaTwo: "IO",
     AlphaThree: "IOT"
   },
   {
     Country: "Brunei Darussalam",
     AlphaTwo: "BN",
     AlphaThree: "BRN"
   },
   {
     Country: "Bulgaria",
     AlphaTwo: "BG",
     AlphaThree: "BGR"
   },
   {
     Country: "Burkina Faso",
     AlphaTwo: "BF",
     AlphaThree: "BFA"
   },
   {
     Country: "Burundi",
     AlphaTwo: "BI",
     AlphaThree: "BDI"
   },
   {
     Country: "Cabo Verde",
     AlphaTwo: "CV",
     AlphaThree: "CPV"
   },
   {
     Country: "Cambodia",
     AlphaTwo: "KH",
     AlphaThree: "KHM"
   },
   {
     Country: "Cameroon",
     AlphaTwo: "CM",
     AlphaThree: "CMR"
   },
   {
     Country: "Canada",
     AlphaTwo: "CA",
     AlphaThree: "CAN"
   },
   {
     Country: "Cayman Islands (the)",
     AlphaTwo: "KY",
     AlphaThree: "CYM"
   },
   {
     Country: "Central African Republic (the)",
     AlphaTwo: "CF",
     AlphaThree: "CAF"
   },
   {
     Country: "Chad",
     AlphaTwo: "TD",
     AlphaThree: "TCD"
   },
   {
     Country: "Chile",
     AlphaTwo: "CL",
     AlphaThree: "CHL"
   },
   {
     Country: "China",
     AlphaTwo: "CN",
     AlphaThree: "CHN"
   },
   {
     Country: "Christmas Island",
     AlphaTwo: "CX",
     AlphaThree: "CXR"
   },
   {
     Country: "Cocos (Keeling) Islands (the)",
     AlphaTwo: "CC",
     AlphaThree: "CCK"
   },
   {
     Country: "Colombia",
     AlphaTwo: "CO",
     AlphaThree: "COL"
   },
   {
     Country: "Comoros (the)",
     AlphaTwo: "KM",
     AlphaThree: "COM"
   },
   {
     Country: "Congo (the Democratic Republic of the)",
     AlphaTwo: "CD",
     AlphaThree: "COD"
   },
   {
     Country: "Congo (the)",
     AlphaTwo: "CG",
     AlphaThree: "COG"
   },
   {
     Country: "Cook Islands (the)",
     AlphaTwo: "CK",
     AlphaThree: "COK"
   },
   {
     Country: "Costa Rica",
     AlphaTwo: "CR",
     AlphaThree: "CRI"
   },
   {
     Country: "Croatia",
     AlphaTwo: "HR",
     AlphaThree: "HRV"
   },
   {
     Country: "Cuba",
     AlphaTwo: "CU",
     AlphaThree: "CUB"
   },
   {
     Country: "Curaçao",
     AlphaTwo: "CW",
     AlphaThree: "CUW"
   },
   {
     Country: "Cyprus",
     AlphaTwo: "CY",
     AlphaThree: "CYP"
   },
   {
     Country: "Czechia",
     AlphaTwo: "CZ",
     AlphaThree: "CZE"
   },
   {
     Country: "Côte d'Ivoire",
     AlphaTwo: "CI",
     AlphaThree: "CIV"
   },
   {
     Country: "Denmark",
     AlphaTwo: "DK",
     AlphaThree: "DNK"
   },
   {
     Country: "Djibouti",
     AlphaTwo: "DJ",
     AlphaThree: "DJI"
   },
   {
     Country: "Dominica",
     AlphaTwo: "DM",
     AlphaThree: "DMA"
   },
   {
     Country: "Dominican Republic (the)",
     AlphaTwo: "DO",
     AlphaThree: "DOM"
   },
   {
     Country: "Ecuador",
     AlphaTwo: "EC",
     AlphaThree: "ECU"
   },
   {
     Country: "Egypt",
     AlphaTwo: "EG",
     AlphaThree: "EGY"
   },
   {
     Country: "El Salvador",
     AlphaTwo: "SV",
     AlphaThree: "SLV"
   },
   {
     Country: "Equatorial Guinea",
     AlphaTwo: "GQ",
     AlphaThree: "GNQ"
   },
   {
     Country: "Eritrea",
     AlphaTwo: "ER",
     AlphaThree: "ERI"
   },
   {
     Country: "Estonia",
     AlphaTwo: "EE",
     AlphaThree: "EST"
   },
   {
     Country: "Eswatini",
     AlphaTwo: "SZ",
     AlphaThree: "SWZ"
   },
   {
     Country: "Ethiopia",
     AlphaTwo: "ET",
     AlphaThree: "ETH"
   },
   {
     Country: "Falkland Islands (the) [Malvinas]",
     AlphaTwo: "FK",
     AlphaThree: "FLK"
   },
   {
     Country: "Faroe Islands (the)",
     AlphaTwo: "FO",
     AlphaThree: "FRO"
   },
   {
     Country: "Fiji",
     AlphaTwo: "FJ",
     AlphaThree: "FJI"
   },
   {
     Country: "Finland",
     AlphaTwo: "FI",
     AlphaThree: "FIN"
   },
   {
     Country: "France",
     AlphaTwo: "FR",
     AlphaThree: "FRA"
   },
   {
     Country: "French Guiana",
     AlphaTwo: "GF",
     AlphaThree: "GUF"
   },
   {
     Country: "French Polynesia",
     AlphaTwo: "PF",
     AlphaThree: "PYF"
   },
   {
     Country: "French Southern Territories (the)",
     AlphaTwo: "TF",
     AlphaThree: "ATF"
   },
   {
     Country: "Gabon",
     AlphaTwo: "GA",
     AlphaThree: "GAB"
   },
   {
     Country: "Gambia (the)",
     AlphaTwo: "GM",
     AlphaThree: "GMB"
   },
   {
     Country: "Georgia",
     AlphaTwo: "GE",
     AlphaThree: "GEO"
   },
   {
     Country: "Germany",
     AlphaTwo: "DE",
     AlphaThree: "DEU"
   },
   {
     Country: "Ghana",
     AlphaTwo: "GH",
     AlphaThree: "GHA"
   },
   {
     Country: "Gibraltar",
     AlphaTwo: "GI",
     AlphaThree: "GIB"
   },
   {
     Country: "Greece",
     AlphaTwo: "GR",
     AlphaThree: "GRC"
   },
   {
     Country: "Greenland",
     AlphaTwo: "GL",
     AlphaThree: "GRL"
   },
   {
     Country: "Grenada",
     AlphaTwo: "GD",
     AlphaThree: "GRD"
   },
   {
     Country: "Guadeloupe",
     AlphaTwo: "GP",
     AlphaThree: "GLP"
   },
   {
     Country: "Guam",
     AlphaTwo: "GU",
     AlphaThree: "GUM"
   },
   {
     Country: "Guatemala",
     AlphaTwo: "GT",
     AlphaThree: "GTM"
   },
   {
     Country: "Guernsey",
     AlphaTwo: "GG",
     AlphaThree: "GGY"
   },
   {
     Country: "Guinea",
     AlphaTwo: "GN",
     AlphaThree: "GIN"
   },
   {
     Country: "Guinea-Bissau",
     AlphaTwo: "GW",
     AlphaThree: "GNB"
   },
   {
     Country: "Guyana",
     AlphaTwo: "GY",
     AlphaThree: "GUY"
   },
   {
     Country: "Haiti",
     AlphaTwo: "HT",
     AlphaThree: "HTI"
   },
   {
     Country: "Heard Island and McDonald Islands",
     AlphaTwo: "HM",
     AlphaThree: "HMD"
   },
   {
     Country: "Holy See (the)",
     AlphaTwo: "VA",
     AlphaThree: "VAT"
   },
   {
     Country: "Honduras",
     AlphaTwo: "HN",
     AlphaThree: "HND"
   },
   {
     Country: "Hong Kong",
     AlphaTwo: "HK",
     AlphaThree: "HKG"
   },
   {
     Country: "Hungary",
     AlphaTwo: "HU",
     AlphaThree: "HUN"
   },
   {
     Country: "Iceland",
     AlphaTwo: "IS",
     AlphaThree: "ISL"
   },
   {
     Country: "India",
     AlphaTwo: "IN",
     AlphaThree: "IND"
   },
   {
     Country: "Indonesia",
     AlphaTwo: "ID",
     AlphaThree: "IDN"
   },
   {
     Country: "Iran (Islamic Republic of)",
     AlphaTwo: "IR",
     AlphaThree: "IRN"
   },
   {
     Country: "Iraq",
     AlphaTwo: "IQ",
     AlphaThree: "IRQ"
   },
   {
     Country: "Ireland",
     AlphaTwo: "IE",
     AlphaThree: "IRL"
   },
   {
     Country: "Isle of Man",
     AlphaTwo: "IM",
     AlphaThree: "IMN"
   },
   {
     Country: "Israel",
     AlphaTwo: "IL",
     AlphaThree: "ISR"
   },
   {
     Country: "Italy",
     AlphaTwo: "IT",
     AlphaThree: "ITA"
   },
   {
     Country: "Jamaica",
     AlphaTwo: "JM",
     AlphaThree: "JAM"
   },
   {
     Country: "Japan",
     AlphaTwo: "JP",
     AlphaThree: "JPN"
   },
   {
     Country: "Jersey",
     AlphaTwo: "JE",
     AlphaThree: "JEY"
   },
   {
     Country: "Jordan",
     AlphaTwo: "JO",
     AlphaThree: "JOR"
   },
   {
     Country: "Kazakhstan",
     AlphaTwo: "KZ",
     AlphaThree: "KAZ"
   },
   {
     Country: "Kenya",
     AlphaTwo: "KE",
     AlphaThree: "KEN"
   },
   {
     Country: "Kiribati",
     AlphaTwo: "KI",
     AlphaThree: "KIR"
   },
   {
     Country: "Korea (the Democratic People's Republic of)",
     AlphaTwo: "KP",
     AlphaThree: "PRK"
   },
   {
     Country: "Korea (the Republic of)",
     AlphaTwo: "KR",
     AlphaThree: "KOR"
   },
   {
     Country: "Kuwait",
     AlphaTwo: "KW",
     AlphaThree: "KWT"
   },
   {
     Country: "Kyrgyzstan",
     AlphaTwo: "KG",
     AlphaThree: "KGZ"
   },
   {
     Country: "Lao People's Democratic Republic (the)",
     AlphaTwo: "LA",
     AlphaThree: "LAO"
   },
   {
     Country: "Latvia",
     AlphaTwo: "LV",
     AlphaThree: "LVA"
   },
   {
     Country: "Lebanon",
     AlphaTwo: "LB",
     AlphaThree: "LBN"
   },
   {
     Country: "Lesotho",
     AlphaTwo: "LS",
     AlphaThree: "LSO"
   },
   {
     Country: "Liberia",
     AlphaTwo: "LR",
     AlphaThree: "LBR"
   },
   {
     Country: "Libya",
     AlphaTwo: "LY",
     AlphaThree: "LBY"
   },
   {
     Country: "Liechtenstein",
     AlphaTwo: "LI",
     AlphaThree: "LIE"
   },
   {
     Country: "Lithuania",
     AlphaTwo: "LT",
     AlphaThree: "LTU"
   },
   {
     Country: "Luxembourg",
     AlphaTwo: "LU",
     AlphaThree: "LUX"
   },
   {
     Country: "Macao",
     AlphaTwo: "MO",
     AlphaThree: "MAC"
   },
   {
     Country: "Madagascar",
     AlphaTwo: "MG",
     AlphaThree: "MDG"
   },
   {
     Country: "Malawi",
     AlphaTwo: "MW",
     AlphaThree: "MWI"
   },
   {
     Country: "Malaysia",
     AlphaTwo: "MY",
     AlphaThree: "MYS"
   },
   {
     Country: "Maldives",
     AlphaTwo: "MV",
     AlphaThree: "MDV"
   },
   {
     Country: "Mali",
     AlphaTwo: "ML",
     AlphaThree: "MLI"
   },
   {
     Country: "Malta",
     AlphaTwo: "MT",
     AlphaThree: "MLT"
   },
   {
     Country: "Marshall Islands (the)",
     AlphaTwo: "MH",
     AlphaThree: "MHL"
   },
   {
     Country: "Martinique",
     AlphaTwo: "MQ",
     AlphaThree: "MTQ"
   },
   {
     Country: "Mauritania",
     AlphaTwo: "MR",
     AlphaThree: "MRT"
   },
   {
     Country: "Mauritius",
     AlphaTwo: "MU",
     AlphaThree: "MUS"
   },
   {
     Country: "Mayotte",
     AlphaTwo: "YT",
     AlphaThree: "MYT"
   },
   {
     Country: "Mexico",
     AlphaTwo: "MX",
     AlphaThree: "MEX"
   },
   {
     Country: "Micronesia (Federated States of)",
     AlphaTwo: "FM",
     AlphaThree: "FSM"
   },
   {
     Country: "Moldova (the Republic of)",
     AlphaTwo: "MD",
     AlphaThree: "MDA"
   },
   {
     Country: "Monaco",
     AlphaTwo: "MC",
     AlphaThree: "MCO"
   },
   {
     Country: "Mongolia",
     AlphaTwo: "MN",
     AlphaThree: "MNG"
   },
   {
     Country: "Montenegro",
     AlphaTwo: "ME",
     AlphaThree: "MNE"
   },
   {
     Country: "Montserrat",
     AlphaTwo: "MS",
     AlphaThree: "MSR"
   },
   {
     Country: "Morocco",
     AlphaTwo: "MA",
     AlphaThree: "MAR"
   },
   {
     Country: "Mozambique",
     AlphaTwo: "MZ",
     AlphaThree: "MOZ"
   },
   {
     Country: "Myanmar",
     AlphaTwo: "MM",
     AlphaThree: "MMR"
   },
   {
     Country: "Namibia",
     AlphaTwo: "NA",
     AlphaThree: "NAM"
   },
   {
     Country: "Nauru",
     AlphaTwo: "NR",
     AlphaThree: "NRU"
   },
   {
     Country: "Nepal",
     AlphaTwo: "NP",
     AlphaThree: "NPL"
   },
   {
     Country: "Netherlands (the)",
     AlphaTwo: "NL",
     AlphaThree: "NLD"
   },
   {
     Country: "New Caledonia",
     AlphaTwo: "NC",
     AlphaThree: "NCL"
   },
   {
     Country: "New Zealand",
     AlphaTwo: "NZ",
     AlphaThree: "NZL"
   },
   {
     Country: "Nicaragua",
     AlphaTwo: "NI",
     AlphaThree: "NIC"
   },
   {
     Country: "Niger (the)",
     AlphaTwo: "NE",
     AlphaThree: "NER"
   },
   {
     Country: "Nigeria",
     AlphaTwo: "NG",
     AlphaThree: "NGA"
   },
   {
     Country: "Niue",
     AlphaTwo: "NU",
     AlphaThree: "NIU"
   },
   {
     Country: "Norfolk Island",
     AlphaTwo: "NF",
     AlphaThree: "NFK"
   },
   {
     Country: "Northern Mariana Islands (the)",
     AlphaTwo: "MP",
     AlphaThree: "MNP"
   },
   {
     Country: "Norway",
     AlphaTwo: "NO",
     AlphaThree: "NOR"
   },
   {
     Country: "Oman",
     AlphaTwo: "OM",
     AlphaThree: "OMN"
   },
   {
     Country: "Pakistan",
     AlphaTwo: "PK",
     AlphaThree: "PAK"
   },
   {
     Country: "Palau",
     AlphaTwo: "PW",
     AlphaThree: "PLW"
   },
   {
     Country: "Palestine, State of",
     AlphaTwo: "PS",
     AlphaThree: "PSE"
   },
   {
     Country: "Panama",
     AlphaTwo: "PA",
     AlphaThree: "PAN"
   },
   {
     Country: "Papua New Guinea",
     AlphaTwo: "PG",
     AlphaThree: "PNG"
   },
   {
     Country: "Paraguay",
     AlphaTwo: "PY",
     AlphaThree: "PRY"
   },
   {
     Country: "Peru",
     AlphaTwo: "PE",
     AlphaThree: "PER"
   },
   {
     Country: "Philippines (the)",
     AlphaTwo: "PH",
     AlphaThree: "PHL"
   },
   {
     Country: "Pitcairn",
     AlphaTwo: "PN",
     AlphaThree: "PCN"
   },
   {
     Country: "Poland",
     AlphaTwo: "PL",
     AlphaThree: "POL"
   },
   {
     Country: "Portugal",
     AlphaTwo: "PT",
     AlphaThree: "PRT"
   },
   {
     Country: "Puerto Rico",
     AlphaTwo: "PR",
     AlphaThree: "PRI"
   },
   {
     Country: "Qatar",
     AlphaTwo: "QA",
     AlphaThree: "QAT"
   },
   {
     Country: "Republic of North Macedonia",
     AlphaTwo: "MK",
     AlphaThree: "MKD"
   },
   {
     Country: "Romania",
     AlphaTwo: "RO",
     AlphaThree: "ROU"
   },
   {
     Country: "Russian Federation (the)",
     AlphaTwo: "RU",
     AlphaThree: "RUS"
   },
   {
     Country: "Rwanda",
     AlphaTwo: "RW",
     AlphaThree: "RWA"
   },
   {
     Country: "Réunion",
     AlphaTwo: "RE",
     AlphaThree: "REU"
   },
   {
     Country: "Saint Barthélemy",
     AlphaTwo: "BL",
     AlphaThree: "BLM"
   },
   {
     Country: "Saint Helena, Ascension and Tristan da Cunha",
     AlphaTwo: "SH",
     AlphaThree: "SHN"
   },
   {
     Country: "Saint Kitts and Nevis",
     AlphaTwo: "KN",
     AlphaThree: "KNA"
   },
   {
     Country: "Saint Lucia",
     AlphaTwo: "LC",
     AlphaThree: "LCA"
   },
   {
     Country: "Saint Martin (French part)",
     AlphaTwo: "MF",
     AlphaThree: "MAF"
   },
   {
     Country: "Saint Pierre and Miquelon",
     AlphaTwo: "PM",
     AlphaThree: "SPM"
   },
   {
     Country: "Saint Vincent and the Grenadines",
     AlphaTwo: "VC",
     AlphaThree: "VCT"
   },
   {
     Country: "Samoa",
     AlphaTwo: "WS",
     AlphaThree: "WSM"
   },
   {
     Country: "San Marino",
     AlphaTwo: "SM",
     AlphaThree: "SMR"
   },
   {
     Country: "Sao Tome and Principe",
     AlphaTwo: "ST",
     AlphaThree: "STP"
   },
   {
     Country: "Saudi Arabia",
     AlphaTwo: "SA",
     AlphaThree: "SAU"
   },
   {
     Country: "Senegal",
     AlphaTwo: "SN",
     AlphaThree: "SEN"
   },
   {
     Country: "Serbia",
     AlphaTwo: "RS",
     AlphaThree: "SRB"
   },
   {
     Country: "Seychelles",
     AlphaTwo: "SC",
     AlphaThree: "SYC"
   },
   {
     Country: "Sierra Leone",
     AlphaTwo: "SL",
     AlphaThree: "SLE"
   },
   {
     Country: "Singapore",
     AlphaTwo: "SG",
     AlphaThree: "SGP"
   },
   {
     Country: "Sint Maarten (Dutch part)",
     AlphaTwo: "SX",
     AlphaThree: "SXM"
   },
   {
     Country: "Slovakia",
     AlphaTwo: "SK",
     AlphaThree: "SVK"
   },
   {
     Country: "Slovenia",
     AlphaTwo: "SI",
     AlphaThree: "SVN"
   },
   {
     Country: "Solomon Islands",
     AlphaTwo: "SB",
     AlphaThree: "SLB"
   },
   {
     Country: "Somalia",
     AlphaTwo: "SO",
     AlphaThree: "SOM"
   },
   {
     Country: "South Africa",
     AlphaTwo: "ZA",
     AlphaThree: "ZAF"
   },
   {
     Country: "South Georgia and the South Sandwich Islands",
     AlphaTwo: "GS",
     AlphaThree: "SGS"
   },
   {
     Country: "South Sudan",
     AlphaTwo: "SS",
     AlphaThree: "SSD"
   },
   {
     Country: "Spain",
     AlphaTwo: "ES",
     AlphaThree: "ESP"
   },
   {
     Country: "Sri Lanka",
     AlphaTwo: "LK",
     AlphaThree: "LKA"
   },
   {
     Country: "Sudan (the)",
     AlphaTwo: "SD",
     AlphaThree: "SDN"
   },
   {
     Country: "Suriname",
     AlphaTwo: "SR",
     AlphaThree: "SUR"
   },
   {
     Country: "Svalbard and Jan Mayen",
     AlphaTwo: "SJ",
     AlphaThree: "SJM"
   },
   {
     Country: "Sweden",
     AlphaTwo: "SE",
     AlphaThree: "SWE"
   },
   {
     Country: "Switzerland",
     AlphaTwo: "CH",
     AlphaThree: "CHE"
   },
   {
     Country: "Syrian Arab Republic",
     AlphaTwo: "SY",
     AlphaThree: "SYR"
   },
   {
     Country: "Taiwan (Province of China)",
     AlphaTwo: "TW",
     AlphaThree: "TWN"
   },
   {
     Country: "Tajikistan",
     AlphaTwo: "TJ",
     AlphaThree: "TJK"
   },
   {
     Country: "Tanzania, United Republic of",
     AlphaTwo: "TZ",
     AlphaThree: "TZA"
   },
   {
     Country: "Thailand",
     AlphaTwo: "TH",
     AlphaThree: "THA"
   },
   {
     Country: "Timor-Leste",
     AlphaTwo: "TL",
     AlphaThree: "TLS"
   },
   {
     Country: "Togo",
     AlphaTwo: "TG",
     AlphaThree: "TGO"
   },
   {
     Country: "Tokelau",
     AlphaTwo: "TK",
     AlphaThree: "TKL"
   },
   {
     Country: "Tonga",
     AlphaTwo: "TO",
     AlphaThree: "TON"
   },
   {
     Country: "Trinidad and Tobago",
     AlphaTwo: "TT",
     AlphaThree: "TTO"
   },
   {
     Country: "Tunisia",
     AlphaTwo: "TN",
     AlphaThree: "TUN"
   },
   {
     Country: "Turkey",
     AlphaTwo: "TR",
     AlphaThree: "TUR"
   },
   {
     Country: "Turkmenistan",
     AlphaTwo: "TM",
     AlphaThree: "TKM"
   },
   {
     Country: "Turks and Caicos Islands (the)",
     AlphaTwo: "TC",
     AlphaThree: "TCA"
   },
   {
     Country: "Tuvalu",
     AlphaTwo: "TV",
     AlphaThree: "TUV"
   },
   {
     Country: "Uganda",
     AlphaTwo: "UG",
     AlphaThree: "UGA"
   },
   {
     Country: "Ukraine",
     AlphaTwo: "UA",
     AlphaThree: "UKR"
   },
   {
     Country: "United Arab Emirates (the)",
     AlphaTwo: "AE",
     AlphaThree: "ARE"
   },
   {
     Country: "United Kingdom of Great Britain and Northern Ireland (the)",
     AlphaTwo: "GB",
     AlphaThree: "GBR"
   },
   {
     Country: "United States Minor Outlying Islands (the)",
     AlphaTwo: "UM",
     AlphaThree: "UMI"
   },
   {
     Country: "United States of America (the)",
     AlphaTwo: "US",
     AlphaThree: "USA"
   },
   {
     Country: "Uruguay",
     AlphaTwo: "UY",
     AlphaThree: "URY"
   },
   {
     Country: "Uzbekistan",
     AlphaTwo: "UZ",
     AlphaThree: "UZB"
   },
   {
     Country: "Vanuatu",
     AlphaTwo: "VU",
     AlphaThree: "VUT"
   },
   {
     Country: "Venezuela (Bolivarian Republic of)",
     AlphaTwo: "VE",
     AlphaThree: "VEN"
   },
   {
     Country: "Viet Nam",
     AlphaTwo: "VN",
     AlphaThree: "VNM"
   },
   {
     Country: "Virgin Islands (British)",
     AlphaTwo: "VG",
     AlphaThree: "VGB"
   },
   {
     Country: "Virgin Islands (U.S.)",
     AlphaTwo: "VI",
     AlphaThree: "VIR"
   },
   {
     Country: "Wallis and Futuna",
     AlphaTwo: "WF",
     AlphaThree: "WLF"
   },
   {
     Country: "Western Sahara",
     AlphaTwo: "EH",
     AlphaThree: "ESH"
   },
   {
     Country: "Yemen",
     AlphaTwo: "YE",
     AlphaThree: "YEM"
   },
   {
     Country: "Zambia",
     AlphaTwo: "ZM",
     AlphaThree: "ZMB"
   },
   {
     Country: "Zimbabwe",
     AlphaTwo: "ZW",
     AlphaThree: "ZWE"
   },
   {
     Country: "Åland Islands",
     AlphaTwo: "AX",
     AlphaThree: "ALA"
   }
  ]
  export default AirportCodesData